RivalIQ.module('graph', function (graph, App, Backbone, Marionette, $, _, d3) {

    'use strict';

    VolumeBar.prototype = new graph.Graph();

    function VolumeBar() {
        this.base = graph.Graph;
        this.base();
        this.maxRows = 30;
        this.height = 80;
        this.width = 180;
        this.margin.right = 5;
        this.margin.left = 70;
        this.margin.top = 5;
        this.margin.bottom = 30;
        this.zeroThickness = 2;
        this.shouldRenderAxis = true;
        this.shouldRenderYou = true;
        this.youText = 'You';
    }

    graph.VolumeBar = VolumeBar;

    VolumeBar.prototype.render = function () {

        const me = this;
        this.clearRendering();
        if (!this.shouldRenderAxis) {
            this.margin.right = 5;
            this.margin.left = 5;
            this.margin.top = 5;
            this.margin.bottom = 40;
        }
        const width = this.width - this.margin.right - this.margin.left;
        const height = this.height - this.margin.top - this.margin.bottom - this.zeroThickness;


        const yfilt = _.filter(_.map(this.data, 'y'), function (item) {
            return item !== null;
        });
        const xfilt = _.filter(_.map(this.data, 'x'), function (item) {
            return item !== null;
        });

        let ymin = 0;
        let ymax = _.max(yfilt);
        const xmax = _.max(xfilt);
        const epsilon = 0.00001;

        ymax = ymax * 2.0;
        if (ymin < epsilon && ymin >= 0) {
            ymin = 0;
        }
        if (ymax < epsilon && ymax >= 0) {
            ymax = 2;
        }
        const y = d3.scale.linear()
            .domain([ymin, ymax])
            .range([height, 0]);

        const x = d3.scale.ordinal();

        x.domain(xfilt);
        x.rangeBands([0, width], 0.2, 0.2);
        const yAxis = d3.svg.axis()
            .scale(y)
            .ticks(2)
            .orient('left');

        const svg = d3.select(this.target).append('svg')
            .attr('width', width + this.margin.right + this.margin.left)
            .attr('height', height + this.margin.top + this.margin.bottom)
            .append('g')
            .attr('transform', `translate(${this.margin.left},${this.margin.top})`);


        const key = function (d) {
            return d.x;
        };
        const val = function (d) {
            return d.y;
        };

        const noNullData = _.filter(this.data, function (item) {
            return item.y !== null;
        });
        const bar = svg.selectAll('g.bar')
            .data(noNullData, key)
            .enter().append('g')
            .attr('transform', function (d) {
                return `translate(${x(key(d))},0)`;
            });
        const fnHeight = function (d) {
            return Math.abs(y(val(d)) - y(0)) + me.zeroThickness;
        };

        bar.append('rect')
            .attr('class', function (d) {
                if (d.focus) {
                    return 'x-focus';
                } else {
                    return 'x-regular';
                }
            })
            .attr('width', x.rangeBand())
            .attr('height', fnHeight)
            .attr('y', function (d) {
                let yv;
                if (val(d) >= 0) {
                    yv = height - fnHeight(d);
                } else {
                    yv = height;
                }

                return yv;
            });


        svg.append('g')
            .attr('class', 'y axis')
            .call(yAxis);


        const axisLabels = [
            {
                v: this.dataDateRange.mainPeriodStart.format('ll')
            },
            {
                v: this.dataDateRange.mainPeriodEnd.format('ll')
            }
        ];
        const text = svg.selectAll('text')
            .data(axisLabels, function (d) {
                return d.v;
            })
            .enter().append('g');
        text.append('text')
            .attr('class', function () {
                return 'x-label';
            })
            .attr('x', function (d, i) {
                if (i === 0) {
                    return 0;
                } else {
                    return width;
                }
            })
            .attr('y', function () {
                return height + 10;
            })
            .attr('dx', function (d, i) {
                if (i === 0) {
                    return -5;
                } else {
                    return 5;
                }
            })
            .attr('dy', '1em')
            .attr('text-anchor', function (d, i) {
                if (i === 0) {
                    return 'start';
                } else {
                    return 'end';
                }
            })
            .text(function (d) {
                return d.v;

            });
        const line = d3.svg.line()
            .x(function (d) {
                return d.x;
            })
            .y(function (d) {
                return d.y;
            });
        const labelLine1 = [];
        labelLine1.push({
            x: x(0) + x.rangeBand() / 2,
            y: height + 11
        });
        labelLine1.push({
            x: x(0) + x.rangeBand() / 2,
            y: height + 5
        });
        svg.append('path')
            .attr('class', 'x-label-line axis')
            .attr('d', line(labelLine1));
        const labelLine2 = [];
        labelLine2.push({
            x: x(xmax) + x.rangeBand() / 2,
            y: height + 11
        });
        labelLine2.push({
            x: x(xmax) + x.rangeBand() / 2,
            y: height + 5
        });
        svg.append('path')
            .attr('class', 'x-label-line axis')
            .attr('d', line(labelLine2));

    };

}, window.d3);
